<template>
    <v-navigation-drawer
        id="app-drawer"
        v-model="inputValue"
        app
        dark
        floating
        persistent
        mobile-break-point="991"
        width="260"
    >
        <v-img
            :src="image"
            :gradient="sidebarOverlayGradiant"
            height="100%"
        >
            <v-layout
                class="fill-height"
                tag="v-list"
                column
            >
                <v-list-tile avatar>
                    <v-list-tile-avatar
                        color="transparent"
                    >
                        <v-img
                            :src="logo"
                            height="36"
                            contain
                        />
                    </v-list-tile-avatar>
                    <v-list-tile-title class="title logo-text font-weight-bold">
                        Appmixer
                    </v-list-tile-title>
                </v-list-tile>
                <v-divider />
                <v-list-tile
                    v-if="responsive"
                >
                    <v-text-field
                        class="purple-input search-input"
                        label="Search..."
                        color="purple"
                    />
                </v-list-tile>
                <template
                    v-for="(link, i) in links"
                >
                    <template v-if="link.children">
                        <v-list-group
                            :key="i"
                            class="v-list-item"
                            :prepend-icon="link.icon"
                            :value="false"
                        >
                            <template #activator>
                                <v-list-tile>
                                    <v-list-tile-title>{{ link.text }}</v-list-tile-title>
                                </v-list-tile>
                            </template>

                            <v-list-tile
                                v-for="(child, j) in link.children"
                                :key="`${i}-${j}`"
                                :to="child.to"
                                :active-class="color"
                                avatar
                                class="v-list-item"
                            >
                                <v-list-tile-action>
                                    <v-icon size="small">
                                        {{ child.icon }}
                                    </v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title
                                    v-text="child.text"
                                />
                            </v-list-tile>
                        </v-list-group>
                    </template>

                    <template v-else>
                        <v-list-tile
                            :key="i"
                            :to="link.to"
                            :active-class="color"
                            avatar
                            class="v-list-item"
                        >
                            <v-list-tile-action>
                                <v-icon>{{ link.icon }}</v-icon>
                            </v-list-tile-action>

                            <v-list-tile-title
                                v-text="link.text"
                            />
                        </v-list-tile>
                    </template>
                </template>
            </v-layout>
        </v-img>
    </v-navigation-drawer>
</template>

<script>
// Utilities
import {
    mapMutations,
    mapState
} from 'vuex';

export default {
    data: () => ({
        logo: '/img/appmixer-logo.svg',
        links: [
            {
                to: '/dashboard/modules',
                icon: 'mdi-animation',
                text: 'Connectors'
            },
            {
                to: '/dashboard/service-config',
                icon: 'mdi-settings',
                text: 'Connector Configuration'
            },
            {
                to: '/dashboard/flows',
                icon: 'mdi-sitemap',
                text: 'Flows'
            },
            {
                to: '/dashboard/users',
                icon: 'mdi-account',
                text: 'Users'
            },
            {
                to: '/dashboard/insights',
                icon: 'mdi-view-dashboard',
                text: 'Metrics'
            },
            {
                icon: 'mdi-cogs',
                text: 'System',
                active: false,
                children: [
                    {
                        to: '/dashboard/system-config',
                        icon: 'mdi-laptop',
                        text: 'System Configuration'
                    },
                    {
                        to: '/dashboard/audit-logs',
                        icon: 'mdi-history',
                        text: 'Audit Logs'
                    },
                    {
                        to: '/dashboard/acl',
                        icon: 'mdi-shield',
                        text: 'ACL'
                    },
                    {
                        to: '/dashboard/quotas',
                        icon: 'mdi-bell',
                        text: 'Quotas'
                    },
                    {
                        icon: 'mdi-file-multiple',
                        to: '/dashboard/public-files',
                        text: 'Public Files'
                    }
                ]
            }
        ],
        responsive: false
    }),
    computed: {
        ...mapState('app', ['image', 'color']),
        inputValue: {
            get() {
                return this.$store.state.app.drawer;
            },
            set(val) {
                this.setDrawer(val);
            }
        },
        items() {
            return this.$t('Layout.View.items');
        },
        sidebarOverlayGradiant() {
            return `${this.$store.state.app.sidebarBackgroundColor}, ${this.$store.state.app.sidebarBackgroundColor}`;
        }
    },
    mounted() {
        this.onResponsiveInverted();
        window.addEventListener('resize', this.onResponsiveInverted);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResponsiveInverted);
    },
    methods: {
        ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
        onResponsiveInverted() {
            if (window.innerWidth < 991) {
                this.responsive = true;
            } else {
                this.responsive = false;
            }
        }
    }
};
</script>

<style lang="scss">
#app-drawer {
    .v-list__tile {
        border-radius: 4px;
        .logo-text {
            font-size: 16px !important;
        }
        &--buy {
            margin-top: auto;
            margin-bottom: 17px;
        }
        .v-list__tile {
            padding-left: 0;
        }
    }
    .v-image__image--contain {
        top: 6px;
        height: 70%;
    }

    .v-list__tile__action i {
        font-size: 18px;
    }

    .search-input {
        margin-bottom: 30px !important;
        padding-left: 15px;
        padding-right: 15px;
    }

    div.v-responsive.v-image > div.v-responsive__content {
        overflow-y: auto;
    }

    .v-list {
        background-color: rgb(28, 28, 28);
    }
    .v-list__group {
        .v-list__tile {
            padding-left: 0px;
        }
        &.v-list-item {
            margin-left: 19px;
        }
    }

}
</style>
